var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"Fiyatlar","title":_vm.pageTitle,"links":_vm.breadLinks}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('Banner',{attrs:{"bannerYeri":1}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }